module.exports = __webpack_public_path__ + "img/IMAGE14.5f5f35bb.jpg";